import {ColorFillPropertyType} from '@Components/color-fill';

export enum ColorTypeTab {
  SOLID = 'solid',
  GRADIENT = 'gradient',
}

export const DEFAULT_GRADIENT_TYPE = ColorFillPropertyType.LINEAR;
/** Arrow keys move between the tabs; the tabs share one tab stop. */
export const COLOR_TYPE_TAB_STEP_KEYS: Record<string, number> = {
  ArrowLeft: -1,
  ArrowRight: 1,
};

export interface ColorTypeTabData {
  id: ColorTypeTab;
  text: string;
  testId: string;
}

export interface ColorTypeTabsProps {
  type: ColorFillPropertyType;
  /** When true the items disagree on fill type: no tab is active. */
  isTypeMixed: boolean;

  onChangeType(type: ColorFillPropertyType): void;
}
